import React from 'react';
import PropTypes from 'prop-types';
import compact from 'lodash/compact';
import filter from 'lodash/filter';
import map from 'lodash/map';
import Checkbox from 'zignal-landscape/lib/Checkbox';
import Select from 'zignal-landscape/lib/Select';
import Button from 'zignal-landscape/lib/Button';
import Field from 'zignal-landscape/lib/Field';
import Label from 'zignal-landscape/lib/Label';
import styles from './Schedule.css';
import { isValidEmailAddress } from 'helpers/email';

class Email extends React.Component {
  constructor(props) {
    super(props);
    this.handleRecipientChange = this.handleRecipientChange.bind(this);
    this.handleSubmitClick = this.handleSubmitClick.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);

    const { users } = props;
    this.state = {
      emailToUserIdMapping: users.reduce((mapping, user) => {
        mapping[user.email] = user.id;
        return mapping;
      }, {}),
      emailOptions: users.map((user) => {
        return {
          value: user.email,
          label: `${user.first_name} ${user.last_name}`
        };
      }),
      userIdSelections: [],
      emailSelections: [],
      pdfChecked: true,
      pngChecked: false
    };
  }

  handleRecipientChange(emailSelections) {
    const { emailToUserIdMapping } = this.state;

    // as you can tell by namings -- "Email", "onSendEmailReport" -- Reports used to be email-centric.
    //   then came along the Notifications effort, which needed User IDs.
    //   we kept the UI the same; the Customer selects (and enters) email addresses
    //   then we do a reverse-lookup to (best effort) identify the Users
    const userIdSelections = compact(emailSelections.map((item) => {
      return emailToUserIdMapping[item.value];
    }));

    this.setState({
      userIdSelections,
      emailSelections,
    });
  }

  handleInputChange(key, value) {
    const newState = {};
    newState[key] = value;
    this.setState(newState);
  }

  handleSubmitClick() {
    const { userIdSelections, emailSelections, pdfChecked,
      pngChecked, emailToUserIdMapping } = this.state;
    const { onSendEmailReport } = this.props;

    // don't duplicate a User's email address in the free-form Email list
    const filteredEmailSelections = filter(emailSelections, (selection) => {
      return !emailToUserIdMapping[selection.value];
    });

    let format;
    if (pdfChecked && pngChecked) {
      format = 'both';
    } else if (pdfChecked) {
      format = 'pdf';
    } else if (pngChecked) {
      format = 'png';
    }

    // do not permit state mutation
    onSendEmailReport(userIdSelections, map(filteredEmailSelections, 'value'), format);
  }

  render() {
    const { emailSelections, emailOptions, pdfChecked, pngChecked } = this.state;
    const isSubmitButtonEnabled = (emailSelections.length > 0) && (pdfChecked || pngChecked);
    const recipientText = ((emailOptions.length === 0)
      ? 'Enter email addresses'
      : 'Select recipients or enter email addresses'
    );
    return (
      <div className={styles.container}>
        <div className={styles.form}>
          <Field>
            <Label>Recipients</Label>
            <Select
              isMulti
              allowCreate
              value={emailSelections}
              isValidNewOption={isValidEmailAddress}
              placeholder={recipientText}
              options={emailOptions}
              onChange={this.handleRecipientChange}
            />
          </Field>
          <Field>
            <Label>Delivery Format</Label>
            <Checkbox
              id="formatEmailPDF"
              name="PDF"
              checked={pdfChecked}
              onChange={(e) => this.handleInputChange('pdfChecked', e.target.checked)}
            />
            <Label htmlFor="formatEmailPDF" inline>PDF</Label>
            <Checkbox
              id="formatEmailPNG"
              name="PNG"
              checked={pngChecked}
              onChange={(e) => this.handleInputChange('pngChecked', e.target.checked)}
            />
            <Label htmlFor="formatEmailPNG" inline>PNG</Label>
          </Field>
        </div>
        <div className={styles.submitButton}>
          <Button buttonStyle="positive" disabled={!isSubmitButtonEnabled} onClick={this.handleSubmitClick}>
            Send Report
          </Button>
        </div>
      </div>
    );
  }
}

Email.propTypes = {
  users: PropTypes.array,
  onSendEmailReport: PropTypes.func
};

Email.defaultProps = {
  users: [],
  onSendEmailReport: () => { /* noop */ }
};

export default Email;
